export const FilterArchivesByType = (datas, id) => {
    const collection = [];
    const map = new Map();
    if (!datas.errno) {
        for (const el of datas) {
            if (!map.has(el.aslug) && el.cid === id) {
                map.set(el.aslug, true);
                collection.push({
                    cslug: el.cslug,
                    cname: el.cname,
                    created: el.created,
                    closed: el.closed,
                    aslug: el.aslug,
                    aname: el.aname,
                    aroute: el.aroute,
                    pname: el.pname,
                    pslug: el.pslug,
                    proute: el.proute,
                });
            }
        }
    }
    return collection;
}
